<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar placeholder="Search Equipment" debounce="300" [(ngModel)]="queryText">
        </ion-searchbar>
        <ion-buttons slot="end">
            <ion-button (click)="scanCode()" size="small" color="medium"
                        *ngIf="level < 4 && (document.documentType === 1 || document.documentType === 7)">
                <ion-icon name="barcode" slot="icon-only"></ion-icon>
            </ion-button>
            <ion-button (click)="showAll()" size="small" fill="outline" shape="round"
                        *ngIf="level < 4 && configuration && !configuration.startEquipSelectedFromAllItems"
                        color="medium">
                All<br>Equip
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchEquipment($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Updating Equipment...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-content *ngIf="level === 1">
        <h4 class="ion-padding-start">Select Department</h4>
        <ion-row class="ion-padding-horizontal">
            <ion-col size="4" *ngFor="let d of deptList | filterDepartment: queryText; index as i;"
                     (click)="refineToGroup(d)" class="ion-text-center">
                <div class="circle" [style.background-color]="pickColor(i)">
                    {{d.descr && d.descr.length < 3 ? d.descr : d.descr.substr(0, 3)}}
                </div>
                <ion-label class="ion-text-center" class="smalltext">
                    {{d.descr}}
                </ion-label>
            </ion-col>
        </ion-row>
    </ion-content>

    <ion-content *ngIf="level === 2">
        <h4 class="ion-padding-start">Select Group</h4>
        <ion-row class="ion-padding-horizontal">
            <ion-col size="4" *ngFor="let g of groupList | filterDepartment: queryText; index as i"
                     (click)="refineToProd(g)" class="ion-text-center">
                <div class="circle" [style.background-color]="pickColor(i)">
                    {{g.descr.length < 3 ? g.descr : g.descr.substr(0, 3)}}
                </div>
                <ion-label class="smalltext ion-text-center">
                    {{g.descr}}
                </ion-label>
            </ion-col>
        </ion-row>
    </ion-content>

    <ion-content *ngIf="level === 3">
        <ion-virtual-scroll [items]="equipList | filterDetailLine: queryText">
            <ion-item *virtualItem="let e" (click)="checkPlantStatus(e)">
                <ion-label>
                    <p *ngIf="e.description">{{e.description}}</p>
                    <p *ngIf="e.typ === 'S' && document.documentType !== documentTypes.ORDER
                    && document.documentType !== documentTypes.QUOTATION">Reg: {{e.reg}}</p>
                </ion-label>
                <ion-icon
                        *ngIf="e.stat !== 1 && (document.documentType === 1 || document.documentType === 102 || document.documentType === 19 || document.documentType === 20 ) && e.typ === 'S'"
                        name="man" slot="end"></ion-icon>
            </ion-item>
        </ion-virtual-scroll>
    </ion-content>

    <ion-content *ngIf="level === 4">
        <ion-card>
            <ion-item>
                <ion-label class="ion-text-center">
                    <h4>Plant: {{equipment.pdesc}}</h4>
                    <!--                <h4>{{equipment.description}}</h4>-->
                </ion-label>
            </ion-item>
            <ion-item>
                <ion-label position="floating"><h4>Description</h4></ion-label>
                <ion-input [(ngModel)]="equipmentDescription" [value]="equipmentDescription"
                           [disabled]="overrideDescriptionAllowed.set !== 1"></ion-input>
            </ion-item>
            <ion-item *ngIf="document.documentType === 1 || document.documentType === 102 && equipment.reg">
                <ion-label>Reg: {{equipment.reg}}</ion-label>
            </ion-item>
            <ion-item>
                <ion-label>Weekly:</ion-label>
                <ion-input type="number" [(ngModel)]="weeklyRate" (click)="$event.target.select()"
                           (ionChange)="calculatePrice(); setDiscount();"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label>Discount, %:</ion-label>
                <ion-input [(ngModel)]="discount" (ionChange)="calculatePrice()" type="number"
                           (click)="$event.target.select()"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label class="ion-text-wrap">New Weekly Rate: {{ total }}</ion-label>
            </ion-item>
            <ion-item class="ion-align-items-center"
                      *ngIf="equipment.typ === 'M' || equipment.typ === 'P' || document.documentType !== 1">
                <ion-label>Qty:</ion-label>
                <ion-input [(ngModel)]="equipQty" type="number"></ion-input>
            </ion-item>

            <ion-item (click)="selectDate(1)">
                <ion-label>From Date:</ion-label>
                <ion-label class="ion-text-end">{{ fromDate | date: 'dd/MM/yyyy HH:mm' }}</ion-label>
                <ion-icon slot="end" name="calendar"></ion-icon>
            </ion-item>

            <ion-item (click)="selectDate(2)">
                <ion-label>To Date:</ion-label>
                <ion-label class="ion-text-end">{{ toDate | date: 'dd/MM/yyyy HH:mm' }}</ion-label>
                <ion-icon slot="end" name="calendar"></ion-icon>
            </ion-item>
            <ion-textarea placeholder="Enter a comment here" [(ngModel)]="comment"></ion-textarea>
        </ion-card>

        <ion-fab vertical="bottom" horizontal="end" slot="fixed">
            <ion-fab-button (click)="addEquipment()" color="success">
                <ion-icon name="checkmark"></ion-icon>
            </ion-fab-button>
        </ion-fab>
    </ion-content>
</ion-content>

<ion-footer *ngIf="level < 4">
    <p class="ion-text-center" style="color: darkgrey">Last Update: {{lastUpdate | date: "dd/MM/yyyy HH:mm:ss"}}</p>
</ion-footer>
